module.exports = __webpack_public_path__ + "static/media/hackerCardVisual.77936554.webp";